import API from 'utils/api';
import { formatReceived } from 'utils/formatValues';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'recaudacion/motocicletas/';

/**
 * GET Historial De Placas
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getHistorialDePlacasMotos = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/placas/`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * POST Historial De Placas
  * @param {number} idVehiculo
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postHistorialDePlacasMotos = async (idVehiculo, values) => {
  try {
    const response = await API.post(`${baseURI}${idVehiculo}/placas`, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Historial De Placas
  * @param {number} idVehiculo
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchHistorialDePlacasMotos = async (idVehiculo, values) => {
  try {
    const response = await API.patch(`${baseURI}${idVehiculo}/placas/${values.id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Historial De Placas
 * @param {number} id
 * @param {number} idVehiculo
 * @returns {Promise<object|boolean>}
 */
export const deleteHistorialDePlacasMotos = async (id, idVehiculo) => {
  try {
    const response = await API.delete(`${baseURI}${idVehiculo}/placas/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
